var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"firstpage",on:{"click":function($event){return _vm.close()}}},[(!_vm.minip2)?_c('Header'):_vm._e(),_c('img',{attrs:{"src":_vm.bgSpring,"alt":"","srcset":""}}),(!_vm.minip2)?_c('Footer'):_vm._e(),(!_vm.minip2)?_c('ShareBar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }